// extracted by mini-css-extract-plugin
export var addToCartButton = "_pm-b";
export var arrowButtonContainer = "_pm-9";
export var arrowButtonIcon = "_pm-a";
export var carouselArrowButton = "_pm-6";
export var carouselElementContainer = "_pm-1";
export var left = "_pm-7";
export var productDisplayCarouselContainer = "_pm-0";
export var productTileContainer = "_pm-2";
export var productTileImage = "_pm-4";
export var productTileImageContainer = "_pm-3";
export var productTileTitle = "_pm-5";
export var right = "_pm-8";
export var sliderOverflow = "_pm-c";